export default __webpack_public_path__ + "static/media/tickSymbol.cdfedcc9.png";